import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Element UI 语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import thLocale from 'element-ui/lib/locale/lang/th'
import esLocale from 'element-ui/lib/locale/lang/es'

// 应用语言文件
import en from './lang/en.json'
import zhCN from './lang/zh-CN.json'
import zhTW from './lang/zh-TW.json'
import ja from './lang/ja.json'
import th from './lang/th.json'
import es from './lang/es.json'

Vue.use(VueI18n)

const messages = {
  'zh-CN': {
    ...zhCN,
    ...zhCNLocale
  },
  'zh-TW': {
    ...zhTW,
    ...zhTWLocale
  },
  en: {
    ...en,
    ...enLocale
  },
  ja: {
    ...ja,
    ...jaLocale
  },
  th: {
    ...th,
    ...thLocale
  },
  es: {
    ...es,
    ...esLocale
  }
}

// 从 localStorage 读取保存的语言设置，如果没有则使用默认中文
const savedLocale = localStorage.getItem('locale')
const defaultLocale = savedLocale || 'zh-CN'

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'zh-CN',
  messages,
  missingWarn: false,
  fallbackWarn: false
})

// 暴露全局 $i18n 引用，供非组件模块（如 md-renderer.js）使用
window.$i18n = i18n

export default i18n
